import { Languages } from "../../types";
import { createUserDictionary } from "./CreateUser";
import { UserPagesDescriptions } from "./types";
import { usersDictionary } from "./Users";

export const getUserDescriptions = (systemLang: Languages): UserPagesDescriptions => ({
    USERS: usersDictionary[systemLang],
    CREATE: createUserDictionary[systemLang],
})